import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { importNewModal } from "../../../redux/actions/newModal";
import { Button, Header, Icon } from "semantic-ui-react";
import AsyncButton from 'src/components/general/AsyncButton';
import CustomModal from 'src/components/configuracion/components/customModal';
import "./newModal.scss";

export default function ModalBox() {
  const renderNode = (node) => {
    if (node === null || node === undefined) return null;
    if (React.isValidElement(node)) return node;
    if (Array.isArray(node)) return React.Children.toArray(node);
    const type = typeof node;
    if (type === "string" || type === "number" || type === "boolean") return node;
    return null;
  };

  const dispatch = useDispatch();
  const { showModal } = useSelector((state) => state.newModal);

  const closeModal = () => {
    dispatch(importNewModal({ show: false }));
  };

  const onConfirm = async () => {
    try {
      await showModal.onConfirm()
    } catch (e) {
      console.error(e.message)
    }
  }

  return (
    <CustomModal
      closeIcon
      open={showModal?.show}
      onClose={closeModal}
      size={showModal?.size || 'small'}
      classNameModal={showModal?.classNameModal}
      modalStyle={showModal?.modalStyle}
      dimmer={{ style: { zIndex: 9999, backgroundColor: 'rgba(0,0,0,.6)', backdropFilter: 'blur(3px)' } }}
      renderHeader={
        <Header as="h3" icon={ showModal?.icon || null } content={showModal?.title || ""} />
      }
      content={
        <>
        {(() => {
          const contentNode = renderNode(showModal?.content);
          const subcontentNode = renderNode(showModal?.subcontent);
          const subsubcontentNode = renderNode(showModal?.subsubcontent);
          const childrenNode = renderNode(showModal?.children);

          return (
            <>
              {contentNode && (
                <div>
                  {typeof contentNode === "string" || typeof contentNode === "number" || typeof contentNode === "boolean"
                    ? <Header as="h4">{contentNode}</Header>
                    : contentNode}
                  {subcontentNode && <div>{subcontentNode}</div>}
                </div>
              )}
              {!contentNode && subcontentNode && <div>{subcontentNode}</div>}
              {subsubcontentNode && <div className="mt-2">{subsubcontentNode}</div>}
              {childrenNode && <div>{childrenNode}</div>}
            </>
          );
        })()}
        </>
      }
      customActions={
      <div className={showModal.showDeleteButton ? 'modalForm__content__actionButtons tw-flex tw-w-full tw-items-center tw-justify-between tw-flex-wrap' : 'tw-flex tw-w-full tw-items-center tw-justify-end tw-gap-2 tw-flex-wrap'}>
      { showModal.showDeleteButton &&
          <Button  color='grey' className="modalForm__content__deleteBtn" disabled={showModal?.deleteDisable} onClick={() => showModal.onDelete()}>
            <Icon name='trash alternate outline' /> { showModal?.onDeleteText || "Eliminar" }
          </Button>
      }
      { !showModal.hideCancelButton && <Button onClick={closeModal}>
          { showModal?.cancelButtonIcon && <Icon name={showModal.cancelButtonIcon} /> } { showModal?.onCancelText || "Cancelar" }
          </Button>
      }
      { !showModal.hideAcceptButton && <AsyncButton color='blue' onClick={onConfirm}>
          { showModal?.confirmButtonIcon && <Icon name={showModal.confirmButtonIcon} /> } { showModal?.onConfirmText || "Aceptar" } { showModal?.confirmButtonIconRight && <Icon name={showModal.confirmButtonIconRight} /> }
        </AsyncButton>
      }
      </div>
      }
    />
  )
}
